import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';

@Component({
  selector: '[app-patient-header]',
  imports: [
    FormsModule,
    CommonModule,
    TableModule,
    TranslatePipe
  ],
  standalone: true,
  templateUrl: './patient-header.component.html',
  styles: ``,
})
export class PatientHeaderComponent {
  @Input() showSteps: boolean = false;
  @Input() showStatus: boolean = false;
}
